import React from "react";
import { useTranslation } from "react-i18next";

const RedFlagDeniedPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="workflow-container centered">
      <div className="red-flag-message">
        {t("selfSignIn.denied.unableToComplete")}
        <br />
        {t("selfSignIn.denied.seeAttendant")}
      </div>
    </div>
  );
};

export default RedFlagDeniedPage;
